import React, { useRef, useState } from "react";
import { asuntoAuto, mensajeAuto, importeTxt } from "@/lib/recordatorios";
import { Aviso, Campo, inputCls } from "./ui";

const BOTONES = [["nombre", "Insertar nombre"], ["importe", "Insertar importe"], ["mes", "Insertar mes"], ["año", "Insertar año"], ["fecha", "Insertar fecha"]];
const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

export const textoMensaje = (f) => (f.mensajeEditado ? f.mensaje : mensajeAuto(f.titulo, f.importe !== "" || f.importeDistinto));
export const textoAsunto = (f) => (f.mensajeEditado ? f.asunto : asuntoAuto(f.titulo));

const ejemplo = (txt, d, f) => {
  const imp = f.importeDistinto ? d.importe : f.importe;
  const [y, m, dd] = (f.fecha_inicio || "").split("-");
  return txt.replaceAll("[nombre]", d.nombre || "…").replaceAll("[importe]", importeTxt(imp).replace(" €", "") || "—")
    .replaceAll("[mes]", MESES[Number(m) - 1] || "…").replaceAll("[año]", y || "…").replaceAll("[fecha]", dd ? `${Number(dd)} de ${MESES[Number(m) - 1]} de ${y}` : "…");
};

// Mensaje generado automáticamente; edición opcional con botones comprensibles.
export const MensajeCorreo = ({ f, set }) => {
  const [abierto, setAbierto] = useState(f.mensajeEditado);
  const ref = useRef(null);
  const msg = textoMensaje(f);
  const editar = (v) => set({ mensajeEditado: true, mensaje: v, asunto: textoAsunto(f) });
  const insertar = (k) => {
    const el = ref.current; const t = `[${k}]`;
    const a = el ? el.selectionStart : msg.length; const b = el ? el.selectionEnd : msg.length;
    editar(msg.slice(0, a) + t + msg.slice(b));
    setTimeout(() => { if (el) { el.focus(); el.setSelectionRange(a + t.length, a + t.length); } }, 0);
  };
  const primero = f.destinatarios[0] || { nombre: "" };
  return (
    <div className="space-y-3" data-testid="rp-mensaje">
      <p className="text-base font-semibold text-[#1C2421]">Así quedará el correo{f.destinatarios.length > 1 ? ` para ${primero.nombre || "la primera persona"}` : ""}:</p>
      <div data-testid="rp-mensaje-ejemplo" className="bg-[#FAF8F5] border border-dashed border-[#C9D8CF] rounded-xl px-4 py-3 text-base text-[#1C2421] whitespace-pre-line">{ejemplo(msg, primero, f)}</div>
      <Aviso testid="rp-aviso-envio">AL DÍA preparará el correo, pero nunca lo enviará sin que tú lo revises y pulses Enviar.</Aviso>
      {!abierto ? (
        <button type="button" data-testid="rp-cambiar-mensaje" onClick={() => setAbierto(true)} className="min-h-[48px] text-base font-semibold text-[#3A6B56] underline underline-offset-4">Revisar o cambiar el mensaje</button>
      ) : (
        <div className="space-y-3 bg-white border border-[#E5DFD5] rounded-2xl p-4">
          <Campo label="Asunto del correo" testid="rp-campo-asunto">
            <input data-testid="rp-asunto" className={inputCls} value={textoAsunto(f)} onChange={(e) => set({ mensajeEditado: true, mensaje: msg, asunto: e.target.value })} />
          </Campo>
          <Campo label="Mensaje" testid="rp-campo-texto" ayuda="Lo que aparece entre corchetes se cambiará solo cada vez, por ejemplo [mes] por «noviembre».">
            <textarea ref={ref} data-testid="rp-texto" rows={6} className={`${inputCls} py-3`} value={msg} onChange={(e) => editar(e.target.value)} />
          </Campo>
          <div className="flex flex-wrap gap-2">
            {BOTONES.map(([k, l]) => (
              <button key={k} type="button" data-testid={`rp-insertar-${k}`} onClick={() => insertar(k)} className="min-h-[44px] px-3.5 rounded-xl bg-[#E8F0EC] text-[#2E5645] text-base font-semibold">{l}</button>
            ))}
          </div>
          {f.mensajeEditado && (
            <button type="button" data-testid="rp-mensaje-original" onClick={() => set({ mensajeEditado: false, mensaje: "", asunto: "" })} className="min-h-[44px] text-sm font-semibold text-[#4A5550] underline">Volver al mensaje propuesto</button>
          )}
        </div>
      )}
    </div>
  );
};
